import { useState } from "react";
import {
    FaShieldAlt,
    FaPhone,
    FaEnvelope,
    FaMapMarkerAlt,
    FaUserSecret,
} from "react-icons/fa";

import "./PrivacySettings.css";

function PrivacySettings() {

    const [privacy, setPrivacy] = useState({

        hidePhone: false,

        hideEmail: false,

        shareLocation: true,

        personalizedRecommendations: true,

    });

    const toggle = (key) => {

        setPrivacy((prev) => ({

            ...prev,

            [key]: !prev[key],

        }));

    };

    const Item = ({
        icon,
        title,
        subtitle,
        value,
        onChange,
    }) => (

        <div className="privacy-item">

            <div className="privacy-left">

                <div className="privacy-icon">

                    {icon}

                </div>

                <div>

                    <h4>{title}</h4>

                    <p>{subtitle}</p>

                </div>

            </div>

            <label className="switch">

                <input
                    type="checkbox"
                    checked={value}
                    onChange={onChange}
                />

                <span className="slider"></span>

            </label>

        </div>

    );

    return (

        <div className="privacy-page">

            <div className="privacy-header">

                <FaShieldAlt />

                <div>

                    <h2>

                        Privacy Settings

                    </h2>

                    <p>

                        Control how your information is shared.

                    </p>

                </div>

            </div>

            <div className="privacy-card">

                <Item
                    icon={<FaPhone />}
                    title="Hide Phone Number"
                    subtitle="Providers won't see your phone until needed."
                    value={privacy.hidePhone}
                    onChange={() => toggle("hidePhone")}
                />

                <Item
                    icon={<FaEnvelope />}
                    title="Hide Email Address"
                    subtitle="Keep your email private."
                    value={privacy.hideEmail}
                    onChange={() => toggle("hideEmail")}
                />

                <Item
                    icon={<FaMapMarkerAlt />}
                    title="Share Live Location"
                    subtitle="Allow accurate delivery tracking."
                    value={privacy.shareLocation}
                    onChange={() => toggle("shareLocation")}
                />

                <Item
                    icon={<FaUserSecret />}
                    title="Personalized Recommendations"
                    subtitle="Show foods based on your preferences."
                    value={privacy.personalizedRecommendations}
                    onChange={() =>
                        toggle("personalizedRecommendations")
                    }
                />

            </div>

        </div>

    );

}

export default PrivacySettings;